import { DEFAULT_LIMIT } from '../SearchManager/FormData';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";
import {BrandAndMarketListItem} from "../../../integrated-client";

export interface IFormData {
  showNonEffective: boolean
  label: string | null
  brandAndMarket: BrandAndMarketListItem | null
  offset: number
  limit: number
  total: number
  currentPage: number
}

export class FormData implements IFormData {

  showNonEffective: boolean
  label: string | null
  brandAndMarket: BrandAndMarketListItem | null
  offset: number
  limit: number
  total: number
  currentPage: number

  constructor() {
    this.showNonEffective = false;
    this.label = null;
    this.brandAndMarket = null
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }

}
